import React from 'react';

const categoryColors: Record<string, string> = {
  'Technology': 'bg-blue-500/15 text-blue-400 border-blue-500/30',
  'Food & Beverage': 'bg-orange-500/15 text-orange-400 border-orange-500/30',
  'Retail': 'bg-purple-500/15 text-purple-400 border-purple-500/30',
  'Health & Wellness': 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30',
  'Education': 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30',
  'Finance': 'bg-cyan-500/15 text-cyan-400 border-cyan-500/30',
  'Creative & Design': 'bg-pink-500/15 text-pink-400 border-pink-500/30',
  'Construction': 'bg-amber-500/15 text-amber-400 border-amber-500/30',
  'Transport & Logistics': 'bg-indigo-500/15 text-indigo-400 border-indigo-500/30',
  'Professional Services': 'bg-slate-400/15 text-slate-300 border-slate-400/30',
  'Entertainment': 'bg-rose-500/15 text-rose-400 border-rose-500/30',
  'Other': 'bg-zinc-600/30 text-zinc-400 border-zinc-600/40',
};

interface BadgeProps {
  category: string;
  className?: string;
}

export default function Badge({ category, className = '' }: BadgeProps) {
  const colorClass = categoryColors[category] ?? categoryColors['Other'];
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${colorClass} ${className}`}
    >
      {category}
    </span>
  );
}

export { categoryColors };